<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>课前预习</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 20px" @keyup.enter="search">
    <Form ref="previewForm" class="form"
          :model="formData" :label-width="80" label-position="left">
      <Row :gutter="32">
        <Col :span="5">
        <Form-item label="教材版本">
          <Select v-model="queryParam.materialVersion" clearable @on-change="onVersionChange">
            <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="课程等级">
          <Select v-model="queryParam.levelId" clearable filterable @on-change="onLevelChange">
            <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="课程标题">
          <Select v-model="queryParam.id" clearable filterable @on-change="onLessonChange">
            <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="预习题标题">
          <Input placeholder="支持模糊查询" v-model="queryParam.title"/>
        </Form-item>
        </Col>
        <Col>
          <Button type="primary" @click="search">搜索</Button>
        </Col>
    </Row>
    </Form>
    <div class="btn-wrap">
      <Button type="primary" @click="addNativePreview">新增本地课前预习</Button>
    </div>
    </div>
    <List style="margin-top: 10px" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/lessonPreview/listByPage"
          :params="queryParam"></List>
    <LessonPreviewInsertModal :successCallback="search" @on-close="closeModal" :value="insertPreviewModal"></LessonPreviewInsertModal>
    <LessonPreviewUpdateModal :successCallback="search" :previewId="previewId" @on-close="closeModal" :value="updatePreviewModal"></LessonPreviewUpdateModal>
    <NativeLessonPreviewInsertModal @on-close="closeModal" :value="nativeInsertModal" :successCallback="search"></NativeLessonPreviewInsertModal>
    <NativeLessonPreviewUpdateModal :previewId="previewId" @on-close="closeModal" :value="nativeUpdateModal" :successCallback="search"></NativeLessonPreviewUpdateModal>
  </div>
</template>
<script>
  import LessonPreviewInsertModal from './LessonPreviewInsertModal'
  import LessonPreviewUpdateModal from './LessonPreviewUpdateModal'
  import NativeLessonPreviewInsertModal from './NativeLessonPreviewInsertModal'
  import NativeLessonPreviewUpdateModal from './NativeLessonPreviewUpdateModal'
import Row from 'iview/src/components/grid/row';
  export default {
    components: {
      NativeLessonPreviewInsertModal,
      NativeLessonPreviewUpdateModal,
      LessonPreviewInsertModal,
      LessonPreviewUpdateModal
    },
    data () {
      return {
        searchLoading: false,
        reload: 0,
        insertPreviewModal: false,
        updatePreviewModal: false,
        nativeInsertModal: false,
        nativeUpdateModal: false,
        previewId: null,
        onLoading: false,
        queryParam: {
          materialVersion: '',
          title: '',
          levelId: '',
          lessonId: '',
        },
        levels: [],
        lessons: [],
        defaultPicList: [],
        defaultPicsList: [],
        defaultFileList: [],
        formData: {
        },
        formRule: {
        },
        editModal: false,
        loadingInsert: false,
        title: [
          {
            title: 'ID',
            key: 'id',
            // width: 80
            align: 'center',
          },
          {
            title: '预习题标题',
            key: 'title',
            // width: 170,
            align: 'center',
          },
          {
            title: '教材版本',
            key: 'version',
            // width: 100,
            align: 'center',
          },
          {
            title: '课程等级',
            key: 'levelTitle',
            // width: 150,
            align: 'center',
          },
          {
            title: '课程标题',
            key: 'lessonTitle',
            // width: 170,
            align: 'center',
          },
          {
            title: '状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              if (row.status === 0) {
                return h('span', '未启用')
              } else if (row.status === 1) {
                return h('span', '启用')
              } else if (row.status === -1) {
                return h('span', '禁用')
              } else if (row.status === 2) {
                return h('span', '预览')
              }
            }
          },
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            width: 170
          },
          {
            title: '更新时间',
            key: 'updateTime',
            align: 'center',
            width: 170
          },
          {
            title: '操作',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              // return h('a', {on: {click: () => this.editLesson(row.id)}}, '编辑')
              return h('span', [
                h('a', {on: {click: () => this.editLesson(row.id)}}, '编辑'),
                h('span', ' | '),
                h('a', {on: {click: () => this.showIndex(row.id)}}, '预览'),
              ])
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      showIndex (id) {
        this.$http.get('/lessonPreview/queryById?id=' + id).then(function (res) {
          if (res.data.indexUrl) {
            window.open(res.data.indexUrl + '?' + Date.parse(new Date()))
          }
        })
      },
      addNativePreview () {
        this.nativeInsertModal = true
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
        this.search()
      },
      editLesson (val) {
        this.previewId = val
        this.nativeUpdateModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLessonChange (val) {
        this.queryParam.lessonId = val
        this.search()
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
        this.search()
      },
      closeModal () {
        this.previewId = null
        this.insertPreviewModal = false
        this.updatePreviewModal = false
        this.nativeInsertModal = false
        this.nativeUpdateModal = false
      },
      addPreview () {
        this.insertPreviewModal = true
      },
    },
    watch: {
    }
  }

</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// LessonPreviewList.vue?1a510d43